import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import PaymentWizard from "components/PaymentWizard/PaymentWizard";

class PayView extends Component {
  render() {
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={10} mdOffset={1}>
              <Card
                ctTableFullWidth
                ctTableResponsive
                content={
                  <PaymentWizard />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
export default PayView;


// WEBPACK FOOTER //
// ./src/views/Pay/PayView.jsx